import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { clearAutoComplete, setEmptyAutocomplete, unRegisterAutoComplete, updateAutoComplete } from 'actions/autoComplete';
import styles from 'styles/components/common/autoComplete.scss';

export class AutoComplete extends Component {
  componentDidMount() {
    const { clearAutoComplete, id } = this.props;
    clearAutoComplete(id);
  }

  componentDidUpdate(prevProps) {
    const { autoComplete } = this.props;
    const { id, setEmptyAutocomplete } = prevProps;
    if (!autoComplete[id].values && this.inputRef.value) {
      this.inputRef.value = '';
    }
    if (autoComplete[id].values && autoComplete[id].values.length === 0 && this.inputRef.value) {
      if (autoComplete[id].isEmpty) {
        setEmptyAutocomplete(id);
      }
    }
  }

  componentWillUnmount() {
    const { unRegisterAutoComplete, id } = this.props;
    unRegisterAutoComplete(id);
  }

  filterVal = e => {
    const { values, handler, updateAutoComplete, id } = this.props;
    const searchText = e.target.value;
    const matchedValues = values.filter(v => handler(v, searchText));
    updateAutoComplete(id, searchText, matchedValues);
  }

  submit(e) {
    e.preventDefault();
  }

  render() {
    const { title } = this.props;
    const { testId } = this.context;
    return (
      <form
        method="post"
        className={styles.autoComplete}
        onSubmit={this.submit}
        role="search"
        aria-label={title}>
        <input
          type="text"
          id={title}
          data-test-id={testId(`autoComplete-${title}`)}
          ref={e => this.inputRef = e}
          placeholder={`Search ${title}`}
          onChange={this.filterVal}/>
        <label htmlFor={title} className="screenReadersOnly">Narrow Your {title} choices</label>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    autoComplete: state.autoComplete
  };
}

AutoComplete.contextTypes = {
  testId: PropTypes.func
};

export default connect(mapStateToProps, {
  clearAutoComplete,
  unRegisterAutoComplete,
  updateAutoComplete,
  setEmptyAutocomplete
})(AutoComplete);
